import React, { useEffect, useLayoutEffect, useState } from 'react';
import styles from './index.module.scss';
import twidLogo from '../../assets/global/twid.svg';
import backArrow from '../../assets/global/arrow-left.svg';
import { useNavigateRoute } from '../../hooks/custom.hooks';

interface AppLayoutProps {
  restrictedHeight?: boolean;
  hideBack?: boolean;
  gobackAction?: void;
  showLogo?: boolean;
  customHeader?: void | undefined;
  children?: React.ReactNode;
  customFooter?: void | undefined;
}

function AppLayout(props: AppLayoutProps) {
  const [height, setHeight] = useState(0);
  const {
    restrictedHeight,
    hideBack,
    showLogo,
    customHeader,
    customFooter,
    gobackAction,
    children,
  } = props;

  useLayoutEffect(() => {
    if (restrictedHeight) {
      const headerHeight =
        document.getElementById('appHeaderMain')?.clientHeight || 0;
      const footerHeight =
        document.getElementById('appFooter')?.clientHeight || 0;
      setHeight(headerHeight + footerHeight);
    }
  }, [restrictedHeight]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigateRoute = useNavigateRoute();
  return (
    <div className={styles.appLayoutGlobal}>
      <div className={styles.appHeader} id="appHeaderMain">
        {hideBack ? null : (
          <img
            src={backArrow}
            alt="<"
            className={styles.back}
            onClick={() => {
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              typeof gobackAction === 'function'
                ? gobackAction?.()
                : navigateRoute({ nextPage: '/' });
            }}
          />
        )}
        {showLogo ? <img src={twidLogo} alt="twid" /> : null}
        {typeof customHeader === 'function' ? (
          <div className={styles.customHeader}>{customHeader?.()}</div>
        ) : null}
      </div>
      <div
        className={styles.content}
        style={{
          height: restrictedHeight ? `calc(100dvh - ${height}px)` : '100%',
        }}
      >
        {children}
      </div>
      <div className={styles.appFooter} id="appFooter">
        {typeof customFooter === 'function' ? (
          <div className={styles.customFooter}>{customFooter?.()}</div>
        ) : null}
      </div>
    </div>
  );
}

export default AppLayout;
